import type { FC } from 'react';

interface Props {
  className?: string;
}

const YogaIcon: FC<Props> = ({ className = 'w-5 h-5 mr-1' }) => {
  return (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <circle cx="12" cy="6" r="3" strokeWidth="2" />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M12 10v4l-4 4m8-4l-4-4M8 18l-2 2m12-2l2 2"
      />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2 22h20" />
    </svg>
  );
};

export default YogaIcon;
